<template>
  <div @keyup.enter.prevent="applyAndClose">
    <UiModal class="is-small" close-on-overlay @close="close">
      <template slot="header">
        <div class="modal-card-title">Применить пресет</div>
      </template>

      <template slot="content">
        <DataBox :loading="isLoading" :error="error">
          <div v-if="!isLoading && noPresets">Список пресетов пуст.</div>
          <div v-else>
            <div v-for="(preset, i) in presets" :key="i" class="wrapper-item">
              <UiRadio
                class="radio-item"
                :name="'option' + i"
                :option-value="preset.id"
                :label="preset.name"
                :model="selectedPresetId"
                @change="(value) => (selectedPresetId = value)"
              />
              <div title="Удалить пресет" class="delete" @click="deletePreset(preset)">
                <UiBaseIcon width="14px" height="14px" color="#9DA9B8" icon-name="close" />
              </div>
            </div>
          </div>
        </DataBox>
      </template>

      <template v-if="!isLoading && !noPresets" slot="footer">
        <UiButton class="button is-blue is-outlined" @click="applyAndClose"> Применить </UiButton>
      </template>
    </UiModal>
  </div>
</template>

<script>
import UiModal from '@/components/UiModal.vue'
import UiButton from '@/components/UiButton.vue'
import UiRadio from '@/components/UiRadio.vue'
import DataBox from '@/components/DataBox.vue'

import syncQuery from '@/mixins/syncUrlQuery'

import { PresetsService } from '@/services/presets.service'

export default {
  components: {
    UiModal,
    UiButton,
    UiRadio,
    DataBox,
    UiBaseIcon: () => import('@/components/icons/UiBaseIcon.vue'),
  },
  mixins: [syncQuery],
  data() {
    return {
      error: null,
      isLoading: false,
      selectedPresetId: '',
      presets: [],
    }
  },
  computed: {
    noPresets() {
      return this.presets.length <= 0
    },
  },
  mounted() {
    this.getPresets()
  },
  methods: {
    /**
     * Send request for get presets list.
     */
    async getPresets(id) {
      this.isLoading = true

      try {
        const { data } = await PresetsService.getList()

        this.presets = data.presets

        this.isLoading = false
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message
        this.isLoading = false
      }
    },

    /**
     * Send request for delete preset.
     */
    async deletePreset(preset) {
      try {
        const result = await this.$swal.fire({
          title: 'Удаление пресета',
          text: `Пресет «${preset.name}» будет удален.`,
          showCancelButton: true,
          confirmButtonText: 'Удалить',
          showLoaderOnConfirm: true,
          preConfirm: () => {
            return PresetsService.delete(preset).catch((error) => {
              this.$store.commit('toast/NEW', { type: 'error', message: error.message })
              return false
            })
          },
          allowOutsideClick: !this.$swal.isLoading,
        })
        if (result.isConfirmed) {
          this.$store.commit('toast/NEW', { type: 'success', message: 'Пресет успешно удален.' })

          this.getPresets()
        }

        return result
      } catch (e) {
        this.$store.commit('toast/NEW', { type: 'error', message: e.message, e })
        this.error = e.message
      }
    },

    /**
     * Set url query parameters by preset paremeters.
     * Then close modal.
     */
    applyAndClose() {
      const preset = this.presets.find((preset) => preset.id === this.selectedPresetId)
      if (!preset) this.$store.commit('toast/NEW', { type: 'error', message: 'Выберите пресет.' })

      this.updateQueryParams({ query: { page: null, ...JSON.parse(preset.dataset) } })
      this.close()
    },

    close() {
      this.$emit('update:show', false)
    },
  },
}
</script>

<style lang="scss" scoped>
.wrapper-item {
  padding: 4px 0;
  &:not(:last-child) {
    margin: 0 0 2px 0;
  }

  @include createFlex(flexbox, nowrap, row, space-between, stretch, stretch);

  .delete {
    cursor: pointer;
    opacity: 0.1;
  }

  &:hover {
    .delete {
      opacity: 1;
    }
  }
}
</style>
